import type { AccessScope } from './auth';
import { featureAccessProjectionStatus, isIndependentSelfServiceRoute, managedFeatureForRoute } from './feature-access-projection';
import { canReadHeadquartersFactoryFeature } from './headquarters-factory-read';

/** Only the server's account-bound developer projection may expose the management screen. */
export function canManageSystemFeedback(scope: AccessScope, developerAccount = false) {
  const projection = featureAccessProjectionStatus(scope.featureAccess);
  if (projection.kind === 'enforced') return projection.features.has('product-feedback');
  if (projection.kind === 'malformed') return false;
  return developerAccount === true;
}

export function canDiscoverWorkspaceFeature(featureId: string, scope: AccessScope, developerAccount = false) {
  if (canReadHeadquartersFactoryFeature(scope, featureId)) return true;
  if (['activity-plan', 'equipment-safety-inspection'].includes(featureId) &&
      (scope.resource.kind !== 'site' || scope.developerReadOnly ||
       !['safety-manager', 'safety-staff', 'site-manager'].includes(scope.persona))) return false;
  const projection = featureAccessProjectionStatus(scope.featureAccess);
  if(['activity-plan','equipment-safety-inspection'].includes(featureId))
    return projection.kind==='enforced'&&projection.features.has('site-settings')&&projection.features.has('safety-review');
  if (projection.kind === 'enforced' || projection.kind === 'malformed') {
    if (isIndependentSelfServiceRoute(featureId)) return true;
    const managed = managedFeatureForRoute(featureId);
    if (projection.kind === 'enforced' && managed === 'electronic-approval' && projection.features.has('safety-review')) return true;
    return projection.kind === 'enforced' && managed !== null && projection.features.has(managed);
  }
  return !['product-feedback', 'system-management'].includes(featureId) || canManageSystemFeedback(scope, developerAccount);
}
